import request from '../untils/request'

//echarts热力分析3.0
export const botMon = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/hotSpotAnalysis/gethotSpotAnalysis1',
            params
        })
    }
    //echarts热力分析4.0地域分布
export const getLocalNewsTW = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/hotSpotAnalysis/getLocalNewsTW',
            params
        })
    }
    //echarts热力分析4.0用户画像
export const userportrait = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/hotSpotAnalysis/userportrait',
            params
        })
    }
    //热点分析4.0相关新闻
export const getCrawlNews = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/keyEvent/getCrawlNews',
            params
        })
    }
    //热点分析5.0关键词
export const gethotSpotAnalysis3 = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/hotSpotAnalysis/gethotSpotAnalysis3',
            params
        })
    }
    //热点分析5.0观点
export const viewpoint = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/hotSpotAnalysis/viewpoint',
        params
    })
}

//京开资讯
export const getJinKaiNews = () => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/groupNews/getJinKaiNews',
        })
    }
    // 消防资讯
export const getFireControl = () => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/looklocal/getFireControl',
        })
    }
    //京开资讯 --酒泉
export const getJiuQuanJinKaiNews = () => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/groupNews/getJiuQuanJinKaiNews',
        })
    }
    //外部媒体看本地
export const geBendi = () => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/looklocal/getlooklocalList',
    })
}

//外部媒体看本地   45 域名需要外部媒体看本地   单独
export const getlooklocalListJiuQuan = () => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/looklocal/getlooklocalListJiuQuan',
    })
}
